<div class="extra-large-screen antrag-feedback">
    <div class="absolute-loading" *ngIf="showLoading">
        <div class="lds-ripple"><div></div><div></div></div>
    </div>

    <ng-container *ngIf="!showForm">
        <div class="login-form-section">
            <div class="login-form-container">
                <div class="login-form-header">
                    <a href="/">
                        <img src="/Copeia.svg" alt="Copeia" />
                    </a>
                    <div>
                        <h3>Interaktiver Kostenübernahmeantrag</h3>
                        <h5>zur Behandlung mit Medizinalcannabis</h5>
                    </div>
                </div>
                <div class="login-form-content">
                    <div class="alert alert-danger fade" [class.show]="loginError">Ungültiges Passwort</div>
                    <div class="login-form">
                        <label>Bitte geben Sie ihr zugeteiltes Passwort ein:</label>
                        <input class="form-control mb-2" type="password" [(ngModel)]="inputPassword" placeholder="Passwort" (keyup.enter)="fnValidatePassword()" />
                        <div class="clearfix">
                            <button type="button" class="standard-btn btn-sm float-right" (click)="fnValidatePassword()">Log In</button>
                        </div>
                    </div>
                    <p>Bei Fragen zu dieser Anwendung oder bei Problemen mit ihrem Passwort kontaktieren Sie uns bitte. <a href="mailto:info@copeia.de">E-mail senden</a></p>
                    <p><a href="/cannabisantrag" target="_blank">> Ausführliche Informationen zum Antrag</a></p>
                    <div class="unlocked-section">
                        <img src="/images/icons/Data_unlocked.svg" alt="Data_unlocked.svg" />
                        <h6>Datenschutz</h6>
                        <p>
                            Der Schutz ihrer Daten hat für uns höchste Priorität. Die von Ihnen getätigten Angaben werden von uns nicht
                            erfasst. Wenn Sie den Antrag speichern, werden diese Daten nur lokal auf Ihrem Computer gespeichert.
                        </p>
                        <p>
                            Die persönlichen Daten ihres Patienten (Fragenblock 4) können Sie auch erst angeben, wenn Sie den Antrag
                            drucken oder ggf. das Antragsformular in Word exportieren.
                        </p>
                    </div>
                    <div class="text-right"><small>© Copeia GmbH, {{fullYear}}</small></div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="showForm">
        <app-header headerTitle="Antrag Feedback" [showNav]="false"></app-header>
        <div class="container-xl">
            <div class="form-main-block" id="form-main-block">
                <div class="form-group-block py-4" id="form-group-block">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Status</label>
                                <select class="form-control" [(ngModel)]="selectedStatus">
                                    <ng-container *ngFor="let item of statusList">
                                        <option [value]="item.value">{{item.name}}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Section</label>
                                <select class="form-control" [(ngModel)]="selectedSection">
                                    <ng-container *ngFor="let item of sectionList">
                                        <option [value]="item.value">{{item.name}}</option>
                                    </ng-container>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="multipe-button">
                                <div class="form-group form-button mr-2">
                                    <label>&nbsp;</label>
                                    <button type="button" class="input-button selected" (click)="fnSearchData()"><span>Search</span></button>
                                </div>
                                <div class="form-group form-button">
                                    <label>&nbsp;</label>
                                    <button type="button" class="input-button selected" (click)="downloadExcel()"><span>Download</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="feedback-records" [style.height.px]="contentHeight">
                    <as-split #feedbackSplitter [unit]="'percent'">
                        <as-split-area [size]="feedbackDetail?60:100">
                            <div id="feedbackGrid"></div>
                        </as-split-area>
                        <as-split-area [size]="40" *ngIf="feedbackDetail">
                            <div class="summery-content scrollbar-white">
                                <div class="form-group">
                                    <label>Status</label>
                                    <select class="form-control" [(ngModel)]="feedbackDetail.status" (change)="onChangeFeedback()" *ngIf="!updateStatus">
                                        <ng-container *ngFor="let item of statusChangeList">
                                            <option [value]="item.value">{{item.name}}</option>
                                        </ng-container>
                                    </select>
                                </div>
                                <hr />
                                <div class="abstract">{{feedbackDetail.note}}</div>
                            </div>
                        </as-split-area>
                    </as-split>
                </div>
            </div>
        </div>
    </ng-container>

</div>
